export const authResponseProps = {
    status: false,
    admin: false,
    access_token: '',
    company: {
        name: '', email: ''
    },
    expiration_time: null,
    days_left: 0,
    country_id: 0,        
    locale_info: {
        country_code: '',
        calling_code: '',
        currency_code: '',
        max_fraction: 2,
        thousand_separator: ',',
        decimal_separator: '.'
    },
    accessible_branches: [],
    modules: []
}

export const currencyProps = {
    country_id: 0,
    country_name: '',
    country_icon: '',
    calling_code: '',
    currency_name: '',
    currency_symbol: '',
    default_currency_max_fraction: 2,
    default_currency_thousand_separator: ',',
    default_currency_decimal_separator: '.'
}


// WEBPACK FOOTER //
// ./src/store/modules/master/properties.js